module.exports = __webpack_public_path__ + "img/9788952213457.3f52ac4a.jpg";